export default {
  nav: {
    home: "Home",
    lab: "Repair Lab",
    phones: "Phones",
    showroom: "Showroom",
    visit: "Visit & Contact",
    getEstimate: "Get estimate",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    menu: "Menu",
    sound: "Sound",
    call: "Call",
    tagline: "Phone Repair · Calgary",
  },
  status: {
    openNow: "Open now",
    closed: "Closed",
    until: "until",
    opensToday: "opens today at",
    opensTomorrow: "opens tomorrow at",
    opensSunday: "opens Sunday at",
  },
  hero: {
    h1a: "Broken tech,",
    h1b: "carefully",
    h1c: "brought back.",
    sub: "Next-G Phone Repair repairs phones, laptops and everyday technology at a real Calgary workbench — straight answers, careful work, and nothing starts without your approval.",
    ctaQuote: "Get a repair estimate",
    ctaVisit: "Visit the shop",
    est: "Est. Calgary, AB",
    badge: "Buy & Repair",
  },
  marquee: [
    "Screen repair", "Battery replacement", "Charging ports", "Water damage",
    "Camera modules", "Data recovery", "Laptop care", "Software rescue",
  ],
  process: {
    chapter: "01",
    eyebrow: "The way we work",
    title: "Four steps. No mystery, no pressure.",
    lede: "Every repair at Next-G follows the same honest rhythm — you always know what is happening to your device and what it will cost.",
    steps: [
      { num: "01", title: "Bring it in", body: "Walk in with the device as it is — no appointment, no packaging, no forms. If it got wet, keep it powered off and come straight over." },
      { num: "02", title: "We diagnose", body: "We open it up, test the hardware and tell you in plain language what actually failed — and what did not. No jargon, no guessing." },
      { num: "03", title: "You approve", body: "You get a clear price in CAD before any work begins. Nothing starts until you say yes — and if it is not worth fixing, we tell you that too." },
      { num: "04", title: "Back in your hands", body: "We repair, test every function again, and hand the device back working — with the old part available if you want to see it." },
    ],
  },
  highlights: {
    chapter: "02",
    eyebrow: "What we fix",
    title: "Phones, laptops and everything you rely on daily.",
    items: [
      { title: "Phone repair", body: "Screens, batteries, ports, cameras and water damage for iPhone and Android." },
      { title: "Laptop repair", body: "MacBook and Windows laptops — hardware fixes, upgrades and slow-system rescues." },
      { title: "Software support", body: "Boot loops, failed updates, crashes and account problems sorted calmly." },
      { title: "Device diagnostics", body: "Not sure what is wrong? A bench inspection tells you exactly what is going on." },
      { title: "Accessories showroom", body: "Cases, protectors, chargers, audio and creator gear — fitted in store." },
    ],
  },
  teaser: {
    chapter: "03",
    eyebrow: "Estimate in a minute",
    titleA: "Pick the problem.",
    titleEm: "Then call",
    titleB: "— we'll quote you on the spot.",
    body: "Choose your device and the issue — then call the shop with those details and get a straight, honest price right away.",
    steps: ["Choose your device", "Choose the issue", "Call with the details"],
    ctaStart: "Start the estimate",
    ctaCall: "Call",
    pricesLabel: "Honest starting prices",
    prices: ["Every repair from CA $79", "Screens, batteries, ports, cameras & more", "Free inspection, always"],
  },
  location: {
    chapter: "04",
    eyebrow: "Find the shop",
    titleEm: "— next to TD Bank.",
    lede: "Walk-ins are welcome. Bring the device as it is, and we will take it from there.",
    openMaps: "Open in maps",
    visitContact: "Visit & contact",
  },
  lab: {
    chapter: "The Repair Lab",
    eyebrow: "Services",
    titleA: "Every repair, explained in",
    titleEm: "plain language.",
    lede: "Tap any service to see what it covers and the symptoms it solves. Estimates are always free to ask for — and always approved by you before work begins.",
    notice: "You might notice",
    ask: "Ask for an estimate",
    pricingTitle: "How pricing works here",
    pricingBody: "Online ranges are preliminary planning figures in CAD. The final price is confirmed after we inspect the device, identify the exact model, and check part availability — and work only starts once you approve the quote.",
    ctaTitleA: "Not sure which one fits?",
    ctaTitleEm: "Just ask.",
    ctaBody: "Describe what the device is doing — we will point you to the right repair.",
    ctaQuote: "Get a repair estimate",
    ctaCall: "Call",
    services: {
      screen: {
        title: "Broken screen repair",
        blurb: "Cracked glass, dead pixels, lines across the display or a touch layer that stopped listening. We replace screens on phones, tablets and laptops with quality-matched parts.",
        symptoms: ["Cracked or shattered glass", "Touch not responding", "Lines, spots or black areas", "Screen stays black but phone vibrates"],
      },
      battery: {
        title: "Battery replacement",
        blurb: "If your phone dies at 30%, shuts down in the cold or needs a charger all day, a fresh battery usually brings it back. Health checked before and after.",
        symptoms: ["Battery drains within hours", "Random shutdowns", "Swollen battery pushing the screen up", "Only works while plugged in"],
      },
      charging: {
        title: "Charging-port & power problems",
        blurb: "Loose cables, slow charging or a phone that only charges at one angle. We clean, repair or replace charging ports and trace power issues to the board when needed.",
        symptoms: ["Cable feels loose or falls out", "Charges only at a certain angle", "No charging at all", "Wireless charging works but the port does not"],
      },
      backglass: {
        title: "Back glass & housing damage",
        blurb: "Cracked rear glass and bent frames are more than cosmetic — they let dust and moisture in. We replace back glass and restore housings so the device is sealed again.",
        symptoms: ["Cracked or shattered rear glass", "Sharp edges when holding the phone", "Bent or dented frame", "Camera ring loose or rattling"],
      },
      camera: {
        title: "Camera replacement & repair",
        blurb: "Blurry photos, a shaking lens, focus hunting or a camera app that opens to black. We replace lens glass and camera modules front and rear.",
        symptoms: ["Photos always blurry", "Camera shakes or rattles", "Black screen in the camera app", "Cracked lens glass"],
      },
      water: {
        title: "Water damage assessment",
        blurb: "Liquid inside a device is a race against corrosion. Bring it in powered off — we open it, clean corrosion and assess what can be saved before quoting any work.",
        symptoms: ["Dropped in water or spilled on", "Screen flickering after getting wet", "Phone died after liquid exposure", "Moisture visible under the camera or screen"],
      },
      software: {
        title: "Software, crashes & boot problems",
        blurb: "Stuck on the logo, failed updates, constant crashes or account lockouts. We sort software problems, restore systems and help you get back into your device.",
        symptoms: ["Stuck on the startup logo", "Update failed and device won't boot", "Apps crashing constantly", "Locked out of accounts or device"],
      },
      data: {
        title: "Data recovery & device access",
        blurb: "Photos, contacts and files trapped on a dead or damaged device. We recover data from phones and laptops whenever the hardware allows it — even when the device itself won't turn on.",
        symptoms: ["Device won't turn on but data matters", "Photos or files trapped on a broken phone", "Forgotten passcode situations", "Failing laptop drive"],
      },
      laptop: {
        title: "Laptop hardware & software support",
        blurb: "Screens, keyboards, batteries, storage upgrades, slow systems and malware cleanups — MacBook and Windows laptops get the same careful bench treatment as phones.",
        symptoms: ["Cracked laptop screen", "Keyboard keys dead or typing wrong", "Laptop suddenly very slow", "Won't charge or hold a charge"],
      },
      diagnostics: {
        title: "Diagnostics & repair consultation",
        blurb: "Not sure what's wrong? Bring it in. We inspect the device, tell you what's actually happening in plain language, and quote the repair before any work begins.",
        symptoms: ["Something feels off but unclear what", "Second opinion on another shop's quote", "Older device — is it worth fixing?", "Multiple issues at once"],
      },
      cleaning: {
        title: "Deep cleaning service",
        blurb: "Pocket lint, dust and grime slowly choke speakers, ports and buttons. We open the device and give it a full inside-out clean — it often fixes muffled sound and sticky buttons.",
        symptoms: ["Muffled or quiet speakers", "Charging port full of lint", "Sticky or jammed buttons", "Dust under the camera glass"],
      },
    },
  },
  fixboth: {
    eyebrow: "Phones & laptops",
    title: "Broken phone. Broken laptop. One stop.",
    steps: [
      "iPhone 17 Pro Max — cracked screen & back glass",
      "Windows laptops — HP, Dell & more",
      "MacBooks — screens, batteries, keyboards",
      "Leave with it working like new",
    ],
    cta: "Get a repair estimate",
  },
  buy: {
    shopLink: "Browse the phone rack",
    eyebrow: "New & used phones",
    titleA: "Buy &",
    titleEm: "Repair",
    titleB: "— one shop, both covered.",
    lede: "We sell new and used phones — Samsung, iPhone and Google Pixel — all tested, activated and ready to use. Used means excellent condition only.",
    perks: [
      { title: "6–12 month guarantee", body: "Every phone comes with 6 months up to a full year of guarantee." },
      { title: "Free guard + cover", body: "A high-quality tempered screen guard and a phone cover, free with every phone you buy." },
      { title: "Repeat-buyer discounts", body: "Every purchase adds you to future discounts — the more you shop with us, the more you save." },
      { title: "Tested & activated", body: "Fully tested, activated and ready to use the moment you walk out." },
    ],
    bestPrice: "The best phone prices around Calgary & Edmonton — honestly, all of Alberta.",
    brandsTitle: "What we carry",
    seriesNote: "…and more on the shelf. Call to check what's in stock today.",
    cta: "Call for today's stock",
    iphoneLine: "iPhone 5 and above",
    pixelLine: "Pixel 6 and above",
  },
  showroom: {
    chapter: "The Showroom",
    eyebrow: "Accessories & everyday tech",
    titleA: "A small,",
    titleEm: "carefully kept",
    titleB: "shelf — not a warehouse.",
    lede: "Cases, protection, power and audio, chosen for daily life. Everything here can be fitted or tested on your own device at the counter.",
    groups: { all: "All", phones: "Phones", protection: "Protection", power: "Power", audio: "Audio", wearables: "Wearables", car: "Car", studio: "Studio" },
    availability: "Availability & pricing confirmed in store",
    stripEyebrow: "See it in person",
    stripTitle: "The shelf changes often — the coffee-shop browse is free.",
    stripVisit: "Plan your visit",
    stripQuote: "Get a repair estimate",
    items: {
      phones: { title: "New & used phones", blurb: "Samsung, iPhone and Google Pixel — tested, activated and ready to use, with 6 months to a full year of guarantee." },
      cases: { title: "Phone cases", blurb: "Slim, rugged and clear cases fitted to your exact model — try them on your phone in store." },
      protectors: { title: "Screen guards & camera protection", blurb: "Privacy and tempered glass, plus camera lens protection — installed at the counter while you wait." },
      cables: { title: "Cables & fast chargers", blurb: "Braided USB-C and Lightning cables, plus quality fast chargers for iPhone, Android and tablets." },
      power: { title: "Power banks & chargers", blurb: "Fast wall chargers, wireless chargers, multi-port hubs and power banks for travel days and long commutes." },
      car: { title: "Car gadgets", blurb: "Phone holders and mounts, plus wired and wireless car chargers for every device." },
      audio: { title: "AirPods & headphones", blurb: "AirPods, wireless earbuds and over-ear headphones — everyday listening, sorted." },
      speakers: { title: "Wireless mini speakers", blurb: "Portable, outdoor-ready speakers with big sound in a small body." },
      smartwatches: { title: "Budget smartwatches", blurb: "Everyday smartwatches that measure heart rate, count steps and connect to your phone." },
      memory: { title: "Memory cards", blurb: "microSD cards in every storage size, for phones, cameras and tablets." },
      keyboards: { title: "Keyboards", blurb: "Wired and wireless keyboards for work, study and play." },
      creatorkit: { title: "Content creation kits", blurb: "Ring lights, portable and standing tripods, and much more for creators." },
      creator: { title: "Creator & work-from-home gear", blurb: "Tripods, mounts, ring lights and small desk upgrades for calls, classes and content." },
      addons: { title: "Everyday phone & laptop add-ons", blurb: "Stands, sleeves, hubs and the small things that make your main device easier to live with." },
      preowned: { title: "Devices & replacements", blurb: "Ask at the counter about devices and replacement parts currently on the shelf." },
    },
  },
  visit: {
    chapter: "Visit & Contact",
    eyebrow: "Come by",
    titleA: "The shop on 17th Ave SE,",
    titleEm: "right next to TD Bank.",
    lede: "Walk-ins are welcome during opening hours. Bring the device as it is — no appointment needed.",
    addressLabel: "Address",
    hoursLabel: "Opening hours",
    call: "Call",
    text: "Text the shop",
    email: "Email us",
    openMaps: "Open in maps",
    planEyebrow: "Prefer to plan first?",
    planTitle: "Get a preliminary estimate before you make the trip.",
    planCta: "Get a repair estimate",
    mapTitle: "Map to Next-G Phone Repair",
  },
  quote: {
    eyebrow: "Repair estimate",
    titleA: "A clear number,",
    titleEm: "in about a minute.",
    lede: "Three quick picks tell us what you're dealing with. Then call — we'll give you a clear price on the spot, approved by you before any work begins.",
    step: "Step",
    of: "of",
    stepTitle1: "What are we fixing?",
    stepTitle2: "Which generation, roughly?",
    stepTitle3: "What is it doing?",
    back: "Back",
    preliminary: "Preliminary estimate",
    planning: "planning range",
    factorsTitle: "What shapes the final price",
    factors: [
      "Exact model and part quality available for it",
      "How far the damage has spread inside the device",
      "Part availability and supplier pricing that week",
      "Any extra issues found during the free inspection",
    ],
    disclaimer: "This is a preliminary, non-binding range. Parts, the exact model, diagnosis and availability can change the final price — always confirmed with you before work begins.",
    call: "Call",
    text: "Text this estimate",
    email: "Email the shop",
    startOver: "Start over",
    visitShop: "Visit the shop",
    categories: {
      iphone: { label: "iPhone", blurb: "Every generation, from iPhone 8 to the latest Pro models." },
      android: { label: "Android phone", blurb: "Samsung, Google Pixel and other Android devices." },
      tablet: { label: "Tablet", blurb: "iPad and Android tablets of all sizes." },
      laptop: { label: "Laptop", blurb: "MacBook and Windows laptops, hardware and software." },
    },
    tiers: {
      iphone: {
        older: { label: "Older iPhone", hint: "iPhone 8, X and SE-era devices" },
        recent: { label: "Recent iPhone", hint: "iPhone 11 – 14 era" },
        newest: { label: "Newest / Pro iPhone", hint: "iPhone 15 – 17 and Pro models" },
      },
      android: {
        standard: { label: "Standard Android", hint: "Entry and mid-range phones" },
        recent: { label: "Recent Android", hint: "Recent mainstream models" },
        flagship: { label: "Flagship Android", hint: "Galaxy S / Ultra, Pixel Pro and similar" },
      },
      tablet: {
        standard: { label: "Standard tablet", hint: "Everyday and older tablets" },
        recent: { label: "Recent tablet", hint: "Recent iPad and Android models" },
        pro: { label: "Pro tablet", hint: "iPad Pro and large premium tablets" },
      },
      laptop: {
        standard: { label: "Standard laptop", hint: "Everyday and older laptops" },
        recent: { label: "Recent laptop", hint: "Recent mainstream and ultrabook models" },
        pro: { label: "Gaming / Pro laptop", hint: "Gaming rigs, MacBook Pro and workstations" },
      },
    },
    issues: {
      screen: { label: "Broken screen", hint: "Cracks, dead pixels or touch problems" },
      battery: { label: "Battery replacement", hint: "Fast drain, shutdowns, swelling or poor health" },
      charging: { label: "Charging problem", hint: "Loose port, no charge or intermittent power" },
      backglass: { label: "Broken back glass", hint: "Cracked rear glass or housing damage" },
      camera: { label: "Camera issue", hint: "Lens damage, focus problems or a failed module" },
      water: { label: "Water damage", hint: "Moisture exposure, corrosion or no power" },
      software: { label: "Software issue", hint: "Crashes, updates, boot or account problems" },
      data: { label: "Data recovery", hint: "Photos, files or device-access problems" },
    },
    smsBody: "Hi Next-G, I'm calling about a repair. Device: {device}. Issue: {issue}.",
    emailSubject: "Repair request — Next-G",
    resultTitle: "You're all set — now call it in.",
    callNow: "Call now",
    callLead: "Every repair is different, so we quote you live instead of guessing online. Call with these details and you'll get a straight answer on the spot.",
    readyTitle: "Have these ready when you call",
    ready: ["Your exact model, if you know it", "What the device is doing — or not doing", "When the problem started"],
    noPrice: "Nothing starts without your approval. The price you're quoted on the call is the price you agree to.",
  },
  footer: {
    explore: "Explore",
    talk: "Talk to us",
    hours: "Hours",
    quote: "Get Estimate",
    rights: "Calgary, Alberta",
    line: "Walk-ins welcome · Estimates confirmed before any work begins",
    motto: "Next gen service for the Next gen.",
  },
};
